import { combineReducers } from "redux";

import { analysisReducer } from "@/features/ws-manager";

export const wsManagerReducer = combineReducers({
  analysis: analysisReducer,
});
